import { render, staticRenderFns } from "./FigmaFolderLayer.vue?vue&type=template&id=19e64b96&scoped=true"
import script from "./FigmaFolderLayer.vue?vue&type=script&lang=js"
export * from "./FigmaFolderLayer.vue?vue&type=script&lang=js"
import style0 from "./FigmaFolderLayer.vue?vue&type=style&index=0&id=19e64b96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e64b96",
  null
  
)

export default component.exports